(function () {
  'use strict';

  angular.module('app').component('bookingItemEditPrice', bookingItemEditPrice());

  function bookingItemEditPrice() {
    return {
      bindings: {
        bookingItem: '<',
        booking: '<',
        onBookingItemPriceSaved: '&',
      },
      controller: BookingItemEditPriceComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/' +
        'booking-item-edit-price/booking-item-edit-price.component.html',
    };
  }

  BookingItemEditPriceComponent.$inject = ['TaxService', 'UtilService'];

  function BookingItemEditPriceComponent(TaxService, UtilService) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.$onInit = function () {
      vm.item = angular.copy(vm.bookingItem);

      vm.netPrice = vm.item.net_price;
      vm.pickupPrice = vm.item.pickup_price;
      vm.dropoffPrice = vm.item.dropoff_price;

      vm.calculateTotalPrice();
    };

    vm.calculateTotalPrice = function () {
      vm.item.net_price = vm.netPrice !== undefined ? vm.netPrice : 0;

      let productSaleTaxes = vm.item.sale_taxes;

      let net_price = vm.item.net_price;
      let pickup_price = vm.pickupPrice || 0;
      let dropoff_price = vm.dropoffPrice || 0;
      let discount_price = 0;
      let subtotal_price = net_price + pickup_price + dropoff_price - discount_price;
      let tax_price_percentage = TaxService.getProductTaxesTotalPercentage(productSaleTaxes);
      let tax_exoneration_price_percentage =
        TaxService.getProductTaxesTotalExonerationPercentage(productSaleTaxes);
      let net_tax_price_percentage = tax_price_percentage - tax_exoneration_price_percentage;

      if (vm.booking.discount_coupon_id) {
        if (vm.booking.discount_coupon.discount_type === 'percentage') {
          discount_price = subtotal_price * (vm.booking.discount_coupon.value / 100);
          subtotal_price = subtotal_price - discount_price;
        } else {
          discount_price = vm.booking.discount_coupon.value;
          subtotal_price = subtotal_price - discount_price / (net_tax_price_percentage / 100 + 1);
        }
      }

      vm.item.sale_taxes = TaxService.setProductTaxesAmounts(subtotal_price, productSaleTaxes);

      let tax_price = TaxService.getProductTaxesTotalAmount(vm.item.sale_taxes);
      let tax_exoneration_price = TaxService.getProductTaxesTotalExonerationAmount(
        vm.item.sale_taxes
      );
      let net_tax_price = tax_price - tax_exoneration_price;

      let total_price = subtotal_price + net_tax_price;

      vm.item.net_price = vm.UtilService.roundNum(net_price);
      vm.item.pickup_price = vm.UtilService.roundNum(pickup_price);
      vm.item.dropoff_price = vm.UtilService.roundNum(dropoff_price);
      vm.item.discount_price = vm.UtilService.roundNum(discount_price);
      vm.item.subtotal_price = vm.UtilService.roundNum(subtotal_price);
      vm.item.tax_price = vm.UtilService.roundNum(tax_price);
      vm.item.tax_exoneration_price = vm.UtilService.roundNum(tax_exoneration_price);
      vm.item.net_tax_price = vm.UtilService.roundNum(net_tax_price);
      vm.item.total_price = vm.UtilService.roundNum(total_price);

      let transactionTaxes = vm.item.purchase_taxes.concat(vm.item.sale_taxes);

      if (transactionTaxes.length > 0) {
        vm.item.transaction_taxes = transactionTaxes;
      }
    };

    vm.updateBookingItemPrice = function (isFormValid) {
      if (!isFormValid || vm.item.total_price < vm.item.discount_price) return;

      vm.item.is_custom_price = true;

      // console.log(vm.item);
      // return;

      vm.onBookingItemPriceSaved({ $bookingItem: vm.item });
    };
  }
})();
